import { Box, BoxProps, ColorOptions, IconNew, Spacer, TextNew } from '@jfs/ui-new'
import { Picker } from 'react-native'

interface PaginationProps {
  dataWindow: number
  pageNumber: number
  total: number
  totalPages: number
  setDataWindow: (dataWindow: number) => void
  onPageClick: (pageNumber: number) => void
  onItemsCountSelect: (count: string) => void
}

const Pagination = ({
  onPageClick,
  pageNumber,
  total,
  onItemsCountSelect,
  totalPages,
  dataWindow,
}: PaginationProps) => {
  const dataWindowList = ['10', '20', '50', '100', '200']

  const page = []
  for (let i = 0; i < totalPages; i++) {
    page.push(i)
  }

  const onPrevPress = () => {
    if (pageNumber > 0) {
      onPageClick(pageNumber - 1)
    }
  }

  const onNextPress = () => {
    if (pageNumber < totalPages - 1) {
      onPageClick(pageNumber + 1)
    }
  }

  const getRecords = () => {
    const start = pageNumber * dataWindow + 1
    const final = (pageNumber + 1) * dataWindow
    const end = final > total ? total : final

    return `${start}-${end} of ${total}`
  }

  return (
    <Box {...styles.container}>
      <Box direction={'row'} align={'center'}>
        <TextNew fontSize={13} color={'#0000008a' as ColorOptions} fontFamily={'jiotype-medium'}>
          {'Rows per page:  '}
        </TextNew>
        <Picker itemStyle={styles.pickerItem} style={styles.picker} onValueChange={onItemsCountSelect}>
          {dataWindowList.map((item) => (
            <Picker.Item label={item} value={item} />
          ))}
        </Picker>
        <Spacer size={24} direction="horizontal" />
        <TextNew fontSize={13} color={'#0000008a' as ColorOptions} fontFamily={'jiotype-medium'}>
          {getRecords()}
        </TextNew>
      </Box>
      <Box direction={'row'} align={'center'}>
        <Box {...styles.prevNextButton} onPress={() => onPageClick(0)}>
          <IconNew
            weight={'dense'}
            id={'ARROW_LEFT'}
            color={pageNumber > 0 ? 'TEXT_PRIMARY' : 'BRAND_COLOR_GRAY_1'}
            size={20}
          />
        </Box>
        <Box {...styles.prevNextButton} onPress={onPrevPress}>
          <IconNew
            weight={'dense'}
            id={'ARROW_LEFT'}
            color={pageNumber > 0 ? 'TEXT_PRIMARY' : 'BRAND_COLOR_GRAY_1'}
            size={20}
          />
        </Box>
        <Box {...styles.prevNextButton} onPress={onNextPress}>
          <IconNew
            weight={'dense'}
            id={'ARROW_RIGHT'}
            size={20}
            color={pageNumber < totalPages - 1 ? 'TEXT_PRIMARY' : 'BRAND_COLOR_GRAY_1'}
          />
        </Box>
        <Box {...styles.prevNextButton} onPress={() => onPageClick(totalPages - 1)}>
          <IconNew
            id={'ARROW_RIGHT'}
            color={pageNumber < totalPages - 1 ? 'TEXT_PRIMARY' : 'BRAND_COLOR_GRAY_1'}
            weight={'dense'}
            size={20}
          />
        </Box>
      </Box>
    </Box>
  )
}

const styles = {
  container: {
    p: 'MEDIUM',
    justify: 'flex-end',
    bg: 'WHITE',
    direction: 'row',
    align: 'center',
    flexWrap: 'wrap',
  } as BoxProps,
  pageIndicatorContainer: {
    underlayColor: 'TRANSPARENT',
    width: '32px',
    height: '32px',
    borderRadius: '16px',
    justify: 'center',
    align: 'center',
  } as BoxProps,
  prevNextButton: {
    underlayColor: 'TRANSPARENT',
    direction: 'row',
    justify: 'center',
    align: 'center',
    ph: 'SMALL',
  } as BoxProps,
  picker: {
    borderWidth: 0,
    paddingVertical: 5,
    color: 'DARK_BLUE_NAVY' as ColorOptions,
    fontSize: 13,
  },
  pickerItem: {
    fontSize: 12,
    paddingLeft: 10,
    color: 'DARK_BLUE_NAVY' as ColorOptions,
  },
}

export { Pagination }
